import { SvgIcon } from "@mui/material"

import { ReactComponent as VerticalSigining } from "./VerticalSigning-icon.svg"

export const VerticalSigningIcon = (props) => {
    return (
        <SvgIcon component={VerticalSigining} inheritViewBox {...props} />
    )
}
